'use strict';

var __importDefault = (global && global.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var link_1 = require("./link");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(link_1).default; } });
